export function getCommonAddresses(addressList = []) {
  return addressList
    .filter((item) => item.defaultFlag === '1')
    .map((item) => ({
      country: item.countryName,
      detail: item.address,
    }))
}

export function groupAddressList(addressList = []) {
  const countryMap = new Map()
  addressList.forEach((item) => {
    const key = item.countryName
    if (!countryMap.has(key)) {
      countryMap.set(key, {
        name: item.countryName,
        flag: item.logo,
        addresses: [],
      })
    }
    countryMap.get(key).addresses.push({
      city: item.cityName,
      detail: item.address,
    })
  })
  return Array.from(countryMap.values())
}
